import React from 'react';
import { Field, ErrorMessage, useField } from 'formik';

function ValidatedField(props) {
    let { className } = props;
    const { name, label, placeholder, readOnly, maxLength, errors, touched, onChange } = props;

    className = className || "form-control";
    let showError = errors[name] && touched[name];
    if (showError) {
        className += " is-invalid";
    }
    
    const [field] = useField(Object.assign({}, props, { name: name }, { className: className }));
    const randomAutoComplete = Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
    return (
        <div className="form-group">
            {label && <label htmlFor={name}>{label}</label>}
            <Field id={name} name={name} type="text" placeholder={placeholder} readOnly={readOnly} maxLength={maxLength} className={className} autoComplete={randomAutoComplete} {...field} onChange={onChange ? e => onChange(e, field, props.values, props.setValues) : field.onChange} />
            <ErrorMessage name={name} component="div" className="invalid-feedback" />
        </div>
    )
}

export default ValidatedField;
